/**
 * Makes a photo fill its frame without showing bare margins.
 *
 * When the photo's shape is close to the frame's (within ~25%), it covers
 * the frame edge to edge; at most a thin strip is trimmed. When the shapes
 * are far apart (a wide banner in a square card), the whole photo stays
 * visible and the frame behind it fills with a soft, blurred copy of the
 * same photo instead of empty space.
 *
 * Use as an <img> onLoad handler. The frame is the closest
 * `[data-fit-frame]` ancestor (or the parent); it must be position:
 * relative/absolute with overflow hidden. Styles live in index.css.
 */
export const COVER_TOLERANCE = 1.25;

export const fitToFrame = (event) => {
  const img = event?.target || event;
  if (!img || !img.naturalWidth || !img.naturalHeight) return;
  const frame = img.closest?.('[data-fit-frame]') || img.parentElement;
  if (!frame) return;
  const box = frame.getBoundingClientRect();
  const frameRatio = box.width && box.height ? box.width / box.height : 1;
  const ratio = (img.naturalWidth / img.naturalHeight) / frameRatio;
  const cover = ratio >= 1 / COVER_TOLERANCE && ratio <= COVER_TOLERANCE;
  img.dataset.fit = cover ? 'cover' : 'contain';
  if (cover) {
    delete frame.dataset.fitBackdrop;
    frame.style.removeProperty('--fit-backdrop');
  } else {
    frame.dataset.fitBackdrop = '1';
    frame.style.setProperty('--fit-backdrop', `url("${String(img.currentSrc || img.src).replace(/"/g, '%22')}")`);
  }
};
